import React, { Component } from "react";
import { Segment, Header, Icon, Button, Image } from "semantic-ui-react";
import AppConfigState from "../state/appConfigState";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import AppState from '../state/appState';

@observer
export default class SpecialMessage extends Component {

  getSpecialMessage(pageKey) {
    let data = AppConfigState.getPublishedPageContentWithCurrentLanguage(pageKey);
    let content = "";
    for (let i = 0; i < data.length; i++) {
      content += data[i].content;
    }
    return content;
  }

  render() {
    const { pageKey, showPlaceholder } = this.props;
    console.log('log ~ file: specialMessage.js ~ line 28 ~ SpecialMessage ~ render ~ showPlaceholder', showPlaceholder);

    let contentMsg
    if(AppState.appLoaded){
      contentMsg = this.getSpecialMessage(this.props.pageKey)
    }

    let content = (
      <Segment placeholder className={"special-message " + pageKey}>
        <div dangerouslySetInnerHTML={{ __html: contentMsg }} />
      </Segment>
    );

    if (!contentMsg && showPlaceholder) {
      content = (
        <Segment loading>
         <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
        </Segment>
      );
    } else if (!contentMsg && !showPlaceholder) {
      content = null;
    }

    return (
      <>
      {content}
      </>
    );
  }
}
